// No per-staff color system exists in the app, so a rotation assigns each member
// a stable color by their index in the member list — shown as a small pip beside
// the name (legend, picker rows, and filled day cells all use the same swatch).
// Tailwind classes, matching the app's direct-class convention. Wraps if a role
// has more members than colors.

const SWATCHES = [
  'bg-sky-500',
  'bg-emerald-500',
  'bg-violet-500',
  'bg-amber-500',
  'bg-rose-500',
  'bg-teal-500',
  'bg-orange-500',
  'bg-indigo-500',
  'bg-lime-500',
  'bg-fuchsia-500',
]

export function memberColor(index: number): { swatch: string } {
  const safe = Number.isFinite(index) && index >= 0 ? Math.floor(index) : 0
  return { swatch: SWATCHES[safe % SWATCHES.length] }
}
